import styled from 'styled-components';

export const TitleWrapper = styled.h1`
    font-weight: 500;
    line-height: 1.4;
    color: ${({ theme }) => theme.colors.text.primary};
`;
